<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="width || '20'"
      :height="height || '20'"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-edit-2"
      :class="classStr"
    >
      <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    height: String,
    width: String,
    classStr: String,
  },
  data() {
    return {};
  },
};
</script>
